// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
// import { observable, action } from 'mobx';
// Note:
// @computer: function does some calcultion then set some state(s).
// @action: function sets some state(s) and signal other to use the lastest value(s). 

import { LineBlock, LineBlockDTO } from './lineblock';

// Struct for transfering data for a timeline.
export interface TimelineDataDTO {
  id: number | string;      // eg. 1
  title: string;            // eg. JR001
  elements: LineBlockDTO[]; // eg. [ collect ][ process ][ deliver]
}

// Class to store data for a timeline.
export class TimelineData {
  id: number | string;    // unique id.
  title: string;          // timeline label (ie. job request name).
  elements: LineBlock[];  // array of 'standing' blocks.  Note: used to be @observable.

  // Initiate an instance of the class.
  constructor(dto: Partial<TimelineDataDTO>) {
    this.update(dto);
  }

  // Return the json representation of an instance.
  get asJson(): TimelineDataDTO {
    return {
      id: this.id,
      title: this.title,
      elements: this.elements,
    };
  }

  // Update/set properties of an instance.
  // Input:
  //   newData: struct holding new value for the properties.
  update(newData: Partial<TimelineDataDTO>): TimelineDataDTO {  // used to be @action
    const allData = { ...this.asJson, ...newData }; // merge new data to existing data.  New data does not need to be complete (Partial).

    // onTimeStatus must be in lowercase for matching.
    allData.elements.forEach(function(element) {
      element.onTimeStatus = element.onTimeStatus?.toLocaleLowerCase();
    });

    Object.assign(this, allData); // Set the new properties.

    return this.asJson;
  }
}

export default TimelineData;